
function Logout(){
    sessionStorage.clear();
    window.history.back();
    return <></>
}

export default Logout